/**
 * Token store decouples the API client from React state. The AuthProvider
 * registers a token getter (and a 401 error handler) here; the apiClient
 * reads from this module so it doesn't need to use hooks.
 */

type TokenGetter = () => Promise<string | null>;
type AuthErrorHandler = () => void;

let tokenGetter: TokenGetter | null = null;
let authErrorHandler: AuthErrorHandler | null = null;

export function setTokenGetter(getter: TokenGetter): void {
  tokenGetter = getter;
}

export function clearTokenGetter(): void {
  tokenGetter = null;
  authErrorHandler = null;
}

export function setAuthErrorHandler(handler: AuthErrorHandler): void {
  authErrorHandler = handler;
}

export async function getAccessToken(): Promise<string | null> {
  if (!tokenGetter) return null;
  return tokenGetter();
}

export function notifyAuthError(): void {
  if (authErrorHandler) authErrorHandler();
}
